import React from "react"
import PropTypes from "prop-types"
import "./swappable-benefits-list.scss"
import SwappableBenefit from "./swappable-benefit"
import * as _ from "lodash"

// Component to display the list of benefits given via its props
const SwappableBenefitsList = ({
  benefits,
  onAddBenefit,
  onRemoveBenefit,
  selectedBenefits,
  excludeVAT,
  numberOfSwappableBenefits
}) => {
  const handleAddBenefit = selectedID => onAddBenefit(selectedID)
  const handleRemoveBenefit = selectedID => onRemoveBenefit(selectedID)

  // Don't return anything if there are no benefits
  if (_.isEmpty(Object.keys(benefits))) {
    return null
  }

  return (
    <div className="benefits-list">
      <h4>
        Choose {numberOfSwappableBenefits} free benefit
        {numberOfSwappableBenefits > 1 && "s"}
      </h4>
      {Object.keys(benefits).map(benefitID => (
        <SwappableBenefit
          text={benefits[benefitID].text}
          shortText={benefits[benefitID].shortText}
          cost={benefits[benefitID].cost}
          onAddBenefit={handleAddBenefit}
          onRemoveBenefit={handleRemoveBenefit}
          id={benefitID}
          selectedBenefitIDs={selectedBenefits}
          key={`benefit_${benefitID}`}
          excludeVAT={excludeVAT}
          numberOfSwappableBenefits={numberOfSwappableBenefits}
        />
      ))}
    </div>
  )
}

SwappableBenefitsList.propTypes = {
  benefits: PropTypes.PropTypes.object.isRequired,
  onAddBenefit: PropTypes.func.isRequired,
  onRemoveBenefit: PropTypes.func.isRequired,
  selectedBenefits: PropTypes.arrayOf(PropTypes.string),
  excludeVAT: PropTypes.bool,
  numberOfSwappableBenefits: PropTypes.number
}

SwappableBenefitsList.defaultProps = {
  selectedBenefitIDs: [],
  excludeVAT: false
}

export default SwappableBenefitsList
